import { http } from "@/utils/axios";

/**
 * @msg: 获取我的课程列表
 */
export function getMyOpenCourse(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getMyOpenCourse'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取考试类别
 */
export function getVideoType(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/getVideoType'),
        method: 'get',
        params
    })
}

/**
 * @msg: 获取考试方式
 */
export function getBaseDictType() {
    return http({
        url: http.baseUrl('zkolBaseDictType/getBaseDictType?groupCode=ksfs'),
        method: 'get',
    })
}
/**
 * @msg: 设置考核结束时间
 */
export function updateCheckTime(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/updateCheckTime'),
        method: 'get',
        params
    })
}

/**
 * @msg: 设置线下考试
 */
export function saveOrUpdate(data) {
    return http({
        url: http.baseUrl('zkolOfflineExamsSetting/saveOrUpdate'),
        method: 'post',
        data,
        params: data
    })
}

/**
 * @msg: 设置课程学习时间
 */
 export function updateCourseStudyTime(params) {
    return http({
        url: http.baseUrl('courseTeacherManage/updateCourseStudyTime'),
        method: 'get',
        params
    })
}

/**
 * @msg: 线下考试学生列表
 */
 export function getStudentListByBatchId(params) {
    return http({
        url: http.baseUrl('zkolOfflineExamsSetting/getStudentListByBatchId'),
        method: 'get',
        params
    })
}